import React from 'react';
import analytics from 'shared/lib/analytics';

export default function withAnalytics(Component) {
  const WithAnalytics = (props) => (
    <Component {...props} analytics={analytics} />
  );

  return WithAnalytics;
}